(() => {
  'use strict';
  const T = window.theme || {};

  /* Money */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || T.moneyFormat || '${{amount}}';
    const fmt = (n, d, ts, ds) => {
      ts = ts === undefined ? ',' : ts; ds = ds === undefined ? '.' : ds;
      const parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }
  const stripHtml = (s) => { const d = document.createElement('div'); d.innerHTML = s; return d.textContent; };
  const money = (c) => stripHtml(formatMoney(c));

  /* Gallery */
  function initGallery(gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!track) return;
    const slides = [...track.querySelectorAll('[data-media-id]')];
    const setActive = (id) => thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.galleryThumb === String(id)));
    const goTo = (id) => {
      const slide = slides.find(s => s.dataset.mediaId === String(id));
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(id);
    };
    thumbs.forEach(t => t.addEventListener('click', () => goTo(t.dataset.galleryThumb)));
    if ('IntersectionObserver' in window && thumbs.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(e.target.dataset.mediaId); });
      }, { root: track, threshold: [0.6] });
      slides.forEach(s => io.observe(s));
    }
    gallery.goTo = goTo;
  }
  document.querySelectorAll('[data-gallery]').forEach(initGallery);

  /* Product form */
  function initProductForm(root) {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = root.querySelector('form');
    const fieldsets = [...root.querySelectorAll('[data-option-index]')];
    const idInput = root.querySelector('[data-variant-id]');
    const btn = root.querySelector('[data-add-button]');
    const btnText = root.querySelector('[data-add-text]');
    const errorEl = root.querySelector('[data-form-error]');
    const priceEl = root.querySelector('[data-price-current]');
    const compareEl = root.querySelector('[data-price-compare]');
    const gallery = root.closest('.product-main__grid')?.querySelector('[data-gallery]');
    const addLabel = btnText ? btnText.textContent.trim() : 'Add to cart';
    const isMain = form && form.id === 'product-form-main';

    const selected = () => fieldsets.map(fs => (fs.querySelector('input:checked') || {}).value);
    const find = (opts) => product.variants.find(v => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));

    function update() {
      const opts = selected();
      const variant = find(opts);

      fieldsets.forEach((fs, i) => {
        const choices = fs.querySelectorAll('label.offer, label.pill');
        choices.forEach(l => { const inp = l.querySelector('input'); l.classList.toggle('is-selected', !!inp && inp.checked); });
        const label = fs.querySelector('[data-option-selected]');
        if (label) label.textContent = opts[i] || '';
        choices.forEach(l => {
          const inp = l.querySelector('input');
          const test = opts.slice(); test[i] = inp.value;
          const cv = find(test) || product.variants.find(x => x.options[i] === inp.value);
          l.classList.toggle('is-unavailable', !cv || !cv.available);
          if (!l.classList.contains('offer') || !cv) return;
          const p = l.querySelector('[data-offer-price]');
          const c = l.querySelector('[data-offer-compare]');
          const s = l.querySelector('[data-offer-save]');
          const has = cv.compare_at_price && cv.compare_at_price > cv.price;
          if (p) p.textContent = money(cv.price);
          if (c) c.textContent = has ? money(cv.compare_at_price) : '';
          if (s) s.textContent = has ? 'You save ' + money(cv.compare_at_price - cv.price) : '';
        });
      });

      root.querySelectorAll('[data-offer-pickers]').forEach(panel => {
        panel.hidden = !opts.includes(panel.dataset.offerPickers);
      });

      if (!variant) {
        btn.disabled = true; btnText.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        const has = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !has; compareEl.textContent = has ? money(variant.compare_at_price) : '';
      }
      btn.disabled = !variant.available;
      btnText.textContent = variant.available ? addLabel : 'Sold out';
      if (variant.featured_media && gallery && gallery.goTo) gallery.goTo(variant.featured_media.id);
      if (isMain && window.history.replaceState) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    const setThumb = (sel) => {
      const thumb = sel.closest('.picker').querySelector('[data-picker-thumb]');
      const img = sel.selectedOptions[0] && sel.selectedOptions[0].dataset.img;
      if (thumb) thumb.style.backgroundImage = img ? `url("${img}")` : '';
    };
    const showColor = (name) => {
      if (!gallery || !gallery.goTo || !name) return;
      const key = String(name).trim().toLowerCase();
      const m = (product.media || []).find(x => x.alt && String(x.alt).trim().toLowerCase() === key);
      if (m) gallery.goTo(m.id);
    };
    root.querySelectorAll('.picker__select').forEach(setThumb);
    root.addEventListener('change', (e) => {
      if (e.target.matches('.picker__select')) { setThumb(e.target); showColor(e.target.value); return; }
      if (e.target.closest('[data-option-index]')) update();
    });

    const collectProps = () => {
      const props = {};
      root.querySelectorAll('[data-offer-pickers]:not([hidden]) .picker__select').forEach(sel => { props[sel.dataset.prop] = sel.value; });
      return props;
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      errorEl.hidden = true;
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
      try {
        const res = await fetch((T.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1, properties: collectProps() }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added. Try again.');
        await Cart.refresh();
        Cart.open();
      } catch (err) {
        errorEl.textContent = err.message; errorEl.hidden = false;
      } finally {
        btn.removeAttribute('aria-busy'); btn.disabled = false; update();
      }
    });
  }
  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  /* Cart drawer */
  const Cart = {
    el: document.querySelector('[data-cart-drawer]'),
    lastFocus: null,
    async refresh() {
      const res = await fetch((T.cartUrl || '/cart') + '.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      this.render(cart);
      return cart;
    },
    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(c => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      if (!this.el) return;
      const body = this.el.querySelector('[data-cart-body]');
      const foot = this.el.querySelector('[data-cart-foot]');
      if (!cart.items.length) {
        body.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>';
        foot.hidden = true; return;
      }
      body.innerHTML = cart.items.map((item, i) => {
        const src = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        const img = src ? `<img src="${src}" alt="" loading="lazy" width="80" height="80">` : '';
        const variant = item.variant_title && !/default title/i.test(item.variant_title) ? `<p class="drawer-line__variant">${escapeHtml(item.variant_title)}</p>` : '';
        const props = item.properties ? Object.entries(item.properties).filter(([k, v]) => v && k.charAt(0) !== '_').map(([k, v]) => `<p class="drawer-line__variant">${escapeHtml(k)}: ${escapeHtml(v)}</p>`).join('') : '';
        return `<div class="drawer-line">
          <a href="${item.url}">${img}</a>
          <div><p class="drawer-line__title">${escapeHtml(item.product_title)}</p>${variant}${props}
            <div class="qty" role="group" aria-label="Quantity">
              <button type="button" data-qty="${i + 1}" data-q="${item.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty="${i + 1}" data-q="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="drawer-line__price">${money(item.final_line_price)}</div>
        </div>`;
      }).join('');
      this.el.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
      foot.hidden = false;
    },
    open() {
      if (!this.el) { window.location.href = T.cartUrl || '/cart'; return; }
      this.lastFocus = document.activeElement;
      this.el.hidden = false; document.body.classList.add('drawer-open');
      this.el.querySelector('.drawer__panel').focus();
    },
    close() {
      if (!this.el) return;
      this.el.hidden = true; document.body.classList.remove('drawer-open');
      if (this.lastFocus) this.lastFocus.focus();
    },
    async change(line, quantity) {
      const res = await fetch((T.cartChangeUrl || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      this.render(await res.json());
    }
  };
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && Cart.el) { e.preventDefault(); Cart.refresh().then(() => Cart.open()); return; }
    if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }
    const q = e.target.closest('[data-qty]');
    if (q) Cart.change(Number(q.dataset.qty), Math.max(0, Number(q.dataset.q)));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (Cart.el && !Cart.el.hidden) Cart.close();
    document.querySelectorAll('[data-menu][open]').forEach(d => d.removeAttribute('open'));
  });

  /* Mobile menu: close after choosing a link */
  document.querySelectorAll('[data-menu] a').forEach(a => a.addEventListener('click', () => a.closest('[data-menu]').removeAttribute('open')));

  /* Two sides toggle */
  document.querySelectorAll('[data-looks]').forEach(sec => {
    sec.querySelectorAll('[data-look-btn]').forEach(b => b.addEventListener('click', () => {
      const side = b.dataset.lookBtn;
      sec.querySelectorAll('[data-look-btn]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      sec.querySelectorAll('[data-look]').forEach(img => img.classList.toggle('is-active', img.dataset.look === side));
      sec.querySelectorAll('[data-look-text]').forEach(t => { t.hidden = t.dataset.lookText !== side; });
    }));
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-gallery]').forEach(initGallery);
    e.target.querySelectorAll('[data-product-form]').forEach(initProductForm);
  });
})();
